module.exports = __webpack_public_path__ + "img/banner_mobile_1.ca7d9578.jpeg";